import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { formatDisplayPhone } from "layouts/whatsapp/components/NotificationRecipientsSummary";

/** Celda destinatario: nombre arriba, número abajo (o solo número si no hay nombre). */
export default function RecipientNameCell({ nombre, telefono }) {
  const phone = formatDisplayPhone(telefono);
  const displayName = nombre && String(nombre).trim() ? String(nombre).trim() : null;

  if (!displayName) {
    return (
      <VuiTypography
        variant="button"
        fontWeight="medium"
        sx={{ color: "#FFFFFF", display: "block", lineHeight: 1.45 }}
      >
        {phone}
      </VuiTypography>
    );
  }

  return (
    <VuiBox sx={{ py: 0.25 }}>
      <VuiTypography
        variant="button"
        fontWeight="bold"
        display="block"
        sx={{ color: "#FFFFFF", lineHeight: 1.45 }}
      >
        {displayName}
      </VuiTypography>
      <VuiTypography
        variant="caption"
        display="block"
        sx={{ color: "rgba(203, 213, 225, 0.92)", lineHeight: 1.35 }}
      >
        {phone}
      </VuiTypography>
    </VuiBox>
  );
}
